import { useEffect, useState } from "react";

// Redux

// Services
import { getTranslateByKey } from "@/main/services/utils";

// Types
import { DynamicReportHistoricalResponse } from "@/main/models/response";

// Api

// Components
import KOGSection from "@/main/components/shared/kogSection/kogSection";

import * as S from "./styles";
import BoxGrid from "@/main/components/shared/boxGrid/boxGrid";
import { TableCell, TableRow } from "@mui/material";
import Search from "@mui/icons-material/Search";
import HistoricalDetails from "./historicalDetails/historicalDetails";
import KOGPaginationGrid from "@/main/components/shared/paginationGrid/paginationGrid";
import { DynamicReportHistoryGridRequest } from "@/main/models/request/dynamicReportGridRequest";
import { PaginationEnum } from "@/main/services/enum/PaginationEnum";
import { procurementReportApi } from "@/main/api";

interface IHistoricalScetionProps {
	guidDynamicReport: string;
	isLoadingEdit: boolean;
}

function HistoricSection({ guidDynamicReport, isLoadingEdit }: IHistoricalScetionProps) {
	const ID_SCROLLABLE_TARGET = "id-scrollable-target-historyDynamicReport";

	const [openHistoricalDetailModal, setOpenHistoricalDetailModal] = useState<boolean>(false);
	const [guidDynamicReportHistorical, setGuidDynamicReportHistorical] = useState<string>("");
	const [actionName, setActionName] = useState<string>("");
	const [dataGrid, setDataGrid] = useState<DynamicReportHistoricalResponse[]>([]);
	const [formFilters, setFormFilters] = useState<DynamicReportHistoryGridRequest | null>(null);

	const sizeCollumns = [
		"65%", // action,
		"30%", // Datetime and user
		"50px",
	];

	const rowHeaders = [getTranslateByKey("information.action"), getTranslateByKey("information.dateTimeUser"), ""];

	function onResetSearchHistory() {
		setDataGrid([]);
		setFormFilters(null);
	}

	function setInitialFilter() {
		const request: DynamicReportHistoryGridRequest = {
			guidDynamicReport: guidDynamicReport,
			pageIndex: PaginationEnum.PageIndexIntial,
			pageSize: PaginationEnum.PageSize10,
		};
		setFormFilters(request);
	}

	useEffect(() => {
		if (!isLoadingEdit) {
			onResetSearchHistory();
		}
	}, [isLoadingEdit]);

	useEffect(() => {
		if (!formFilters) {
			setInitialFilter();
		}
	}, [formFilters]);

	async function fetchData(request: any) {
		return procurementReportApi.GetDynamicReportHistoryGrid(request).then((response) => response.data);
	}

	function handleOpenHistoricalDetailModal(guid: string, actionName: string) {
		setGuidDynamicReportHistorical(guid);
		setActionName(actionName);
		setOpenHistoricalDetailModal(true);
	}

	function handleCloseHistoricalDetailModal() {
		setGuidDynamicReportHistorical("");
		setActionName("");
		setOpenHistoricalDetailModal(false);
	}

	return (
		<KOGSection title={getTranslateByKey("information.history")}>
			<S.ContainerBodyHistory id={ID_SCROLLABLE_TARGET}>
				<KOGPaginationGrid
					idScrollableTarget={ID_SCROLLABLE_TARGET}
					dataGrid={dataGrid}
					formFilters={formFilters}
					setDataGrid={setDataGrid}
					fetchMore={fetchData}
				>
					<BoxGrid rowHeaders={rowHeaders} sizeColumns={sizeCollumns} widthCustom="100%">
						{dataGrid.map((historical, index) => {
							return (
								<TableRow id={`id-dynamicReport-historicalList-${index}`} key={index}>
									<TableCell>{historical.dynamicReportActionName}</TableCell>
									<TableCell>{historical.userDate}</TableCell>
									<TableCell width="15%" align="right">
										<S.TableIcons>
											<Search
												fontSize="medium"
												style={{ cursor: "pointer" }}
												onClick={() => {
													handleOpenHistoricalDetailModal(
														historical.guidDynamicReportHistorical,
														historical.dynamicReportActionName,
													);
												}}
											/>
										</S.TableIcons>
									</TableCell>
								</TableRow>
							);
						})}
					</BoxGrid>
				</KOGPaginationGrid>
				<HistoricalDetails
					open={openHistoricalDetailModal}
					closeModal={handleCloseHistoricalDetailModal}
					guidDynamicReportHistorical={guidDynamicReportHistorical}
					actionName={actionName}
				/>
			</S.ContainerBodyHistory>
		</KOGSection>
	);
}

export default HistoricSection;
